module.exports = __webpack_public_path__ + "static/0051-4645d28f83d2f997da664a3cb32218c6.png";